export function isRestoreComment(comment: string | null | undefined): boolean {
  const normalized = (comment || "").trim().toLocaleLowerCase("ru-RU");
  return normalized.includes("восстанов");
}
